import parseISO from 'date-fns/parseISO';
import subMinutes from 'date-fns/subMinutes';

import { useHasCardOnFileFeatureFlag } from 'reservations/account/hooks/featureFlags';
import type { Fee } from 'reservations/booking/types';

export const useLateCancel = (dateAndTime: string, fee: Fee | null) => {
  const hasCardOnFileFeature = useHasCardOnFileFeatureFlag();
  const now = new Date();
  const hasFee = !!fee?.shouldCollect;
  const cancellationDeadline = subMinutes(
    parseISO(dateAndTime),
    fee?.cancelDeadlineMinutes ?? 0
  );
  const isLateCancel =
    hasCardOnFileFeature && hasFee && cancellationDeadline < now;

  return { cancellationDeadline, isLateCancel };
};
